import { render, staticRenderFns } from "./LabelSetting.vue?vue&type=template&id=d716262c&scoped=true"
import script from "./LabelSetting.vue?vue&type=script&lang=ts"
export * from "./LabelSetting.vue?vue&type=script&lang=ts"
import style0 from "./LabelSetting.vue?vue&type=style&index=0&id=d716262c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d716262c",
  null
  
)

export default component.exports